module.exports = __webpack_public_path__ + "media/packs/images/state/small/inland-fa56d820366065c7aecc56f8ae6a7e6c.svg";